import request from "@/utils/request";

// 查询区域树结构
export const  regionTree =(query) =>{
    return request({
        url: "/businessservice/region/gainRegionTree",
        method:"get",
        params: query
    })
}